import React from 'react';
import '../styles/styles.css';

export default function TermsAndConditions() {
  return (
    <section className="page terms">
      <h1>Terms and Conditions</h1>

      <p><strong>Last Updated:</strong> July 11, 2025</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to the official website of <strong>Victor Labs</strong>. By accessing or using this site, 
        you agree to comply with and be bound by these Terms and Conditions. If you do not agree with any 
        part of these terms, please discontinue use of our website immediately.
      </p>

      <h2>2. Intellectual Property</h2>
      <p>
        All content available on this website, including but not limited to text, graphics, logos, icons, 
        images, software code, and design, is the intellectual property of <strong>Victor Labs</strong> 
        unless otherwise stated. Unauthorized reproduction, distribution, or commercial use of this content 
        without prior written consent is strictly prohibited.
      </p>

      <h2>3. Acceptable Use</h2>
      <p>
        By using our website, you agree not to engage in activities that may:
      </p>
      <ul>
        <li>Violate any applicable laws or regulations</li>
        <li>Attempt unauthorized access to our servers or systems</li>
        <li>Introduce malicious software, viruses, or harmful code</li>
        <li>Use the site to harass, defame, or infringe upon the rights of others</li>
      </ul>

      <h2>4. Third-Party Links</h2>
      <p>
        Our website may include links to third-party websites or services for your convenience. 
        <strong>Victor Labs</strong> is not responsible for the content, security, or practices of 
        these external sites. Use of third-party websites is at your own risk and subject to their 
        respective terms and policies.
      </p>

      <h2>5. Limitation of Liability</h2>
      <p>
        This website is provided on an “as is” and “as available” basis without warranties of any kind. 
        <strong>Victor Labs</strong> does not guarantee uninterrupted or error-free operation of the site 
        and shall not be held liable for any direct, indirect, incidental, or consequential damages arising 
        from your use of the website.
      </p>

      <h2>6. Privacy Policy</h2>
      <p>
        Your use of this website is also governed by our <a href="/privacy-policy">Privacy Policy</a>. 
        By continuing to use the site, you acknowledge and consent to the collection and handling of 
        data as described in that policy.
      </p>

      <h2>7. Changes to These Terms</h2>
      <p>
        <strong>Victor Labs</strong> reserves the right to update or modify these Terms and Conditions 
        at any time without prior notice. Any changes will be effective immediately upon posting on this page. 
        Continued use of the website constitutes your acceptance of the revised terms.
      </p>

      <h2>8. Governing Law</h2>
      <p>
        These Terms and Conditions shall be governed by and interpreted in accordance with the laws of Kenya. 
        Any disputes arising under or in connection with these terms shall be subject to the exclusive jurisdiction 
        of the courts of Kenya.
      </p>

      <p>Thank you for visiting our website and for trusting <strong>Victor Labs</strong>.</p>
    </section>
  );
}
